import { render } from "./GuestScheduleUpdatePhoto.vue?vue&type=template&id=61d5c04c&scoped=true"
import script from "./GuestScheduleUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./GuestScheduleUpdatePhoto.vue?vue&type=script&lang=js"

import "./GuestScheduleUpdatePhoto.vue?vue&type=style&index=0&id=61d5c04c&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d5c04c"]])

export default __exports__